export type WipAnalysisGridMetricFormat = "currency" | "ratio-percent" | "complete-percent";

export type WipAnalysisGridMetricId =
	| "contract"
	| "est-cost"
	| "billed-td"
	| "cost-td"
	| "est-ctc"
	| "est-gp"
	| "gp-percent"
	| "pct-comp"
	| "gp-earned"
	| "gp-to-be"
	| "underbillings"
	| "overbillings"
	| "pure-job-borrow"
	| "cash-flow-remaining";

export type WipAnalysisGridMetricDef = {
	id: WipAnalysisGridMetricId;
	/** Column header text, shortened to fit a metric column. */
	label: string;
	/** Full name, for places with room such as the column selector. */
	name: string;
	format: WipAnalysisGridMetricFormat;
};

/** PRD column order for WIP Analysis. */
export const WIP_ANALYSIS_GRID_METRICS: ReadonlyArray<WipAnalysisGridMetricDef> = [
	{ id: "contract", label: "Contract Amount", name: "Contract Amount", format: "currency" },
	{ id: "est-cost", label: "Total Est. Cost", name: "Total Estimated Cost", format: "currency" },
	{ id: "billed-td", label: "Total Billed TD", name: "Total Billed to Date", format: "currency" },
	{ id: "cost-td", label: "Total Cost TD", name: "Total Cost to Date", format: "currency" },
	{
		id: "est-ctc",
		label: "Cost to Complete",
		name: "Estimated Cost to Complete",
		format: "currency",
	},
	{
		id: "est-gp",
		label: "Est. Gross Profit",
		name: "Estimated Gross Profit",
		format: "currency",
	},
	{ id: "gp-percent", label: "GP %", name: "Gross Profit %", format: "ratio-percent" },
	{ id: "pct-comp", label: "% Complete", name: "% Complete", format: "complete-percent" },
	{
		id: "gp-earned",
		label: "GP Earned TD",
		name: "Gross Profit Earned to Date",
		format: "currency",
	},
	{
		id: "gp-to-be",
		label: "GP to be Earned",
		name: "Gross Profit to Be Earned",
		format: "currency",
	},
	{ id: "underbillings", label: "Underbill.", name: "Underbillings", format: "currency" },
	{ id: "overbillings", label: "Overbill.", name: "Overbillings", format: "currency" },
	{
		id: "pure-job-borrow",
		label: "Pure Job Borrow",
		name: "Pure Job Borrow",
		format: "currency",
	},
	{
		id: "cash-flow-remaining",
		label: "Cash Flow Rem.",
		name: "Cash Flow Remaining",
		format: "currency",
	},
];
